import { Item } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class ItemOfflineDataUpdateCacher extends OfflineDataUpdateCacher<Item> {
    constructor() {
        super(dbCacheUp.item)
    }
}